<input type="text" id="scriptHelper" class="sr-only">
<div class="app-loading" *ngIf="loading">
  <div class="logo"></div>
  <svg class="spinner" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
  </svg>
</div>

<div class="main-content" *ngIf="!customize">
  <div class="loader"></div>
</div>

<div class="main-content" *ngIf="customize">

  <div class="container-fluid">

    <div class="title-container" style="display: flex;">
      <div class="left-title" style="width: 70%;">
        <div class="bigheader">
          <div class="col-lg-6 col-md-6">
            <h4>Caixinha de Doação</h4>
            <p class="subtitle">Configure como sua jornada de doação vai acontecer.</p>
          </div>
        </div>
        <!-- Caminho da doação -->
        <div>
          <div class="image-resume">
            <img src="../../assets/img/barra-linha-do-tempo-caixinha-de-doação.png"
              alt="Explicação do caminho da doação dentro do Polen" style="width: 100%;">
          </div>
        </div>
      </div>
      <div class="rigth-title" style="width: 40%;">
        <div class="card actions-customization" style="padding: 1rem;margin-left:2rem">
          <div class="actions-title">
            <h5 style="margin:0; font-weight: 700;">Opções gerais</h5>
            <p style="font-size: 1.6rem;">Edite a visibilidade da ferramenta e veja em tempo real</p>
          </div>
          <div class="visibility" style="border-bottom: 2px solid #d4d4d4; padding-bottom: 1rem;">
            <div style="display: flex;justify-content: space-between;flex-direction: column;margin-right: 2rem;">
              <label tooltip="Defina se a caixa de doação do Polen está aparecendo ou não no seu site.">
                Polen visível no seu site
              </label>
              <div style="display: flex;">
                <select class="form-control" name="integrationActive" style="width: 83%;"
                  [(ngModel)]="profile.integrationActive" (change)="saveProfile()">
                  <option [value]="true">Visibilidade Ativa</option>
                  <option [value]="false">Visibilidade Desativada</option>
                </select>
                <div style="float: left; margin-top: 6px;">
                  <img *ngIf="profile.integrationActive" style="width:30px; margin-left:10px;"
                    title="Visualização Ativada!" src="../../assets/img/icon/ok_button.png" />
                  <img *ngIf="!profile.integrationActive" style="width:30px; margin-left:10px;"
                    title="Visualização desativada!" src="../../assets/img/icon/stop_button.png" />
                </div>
              </div>
            </div>
          </div>
          <div class="actions-go-to" style="border-bottom: 2px solid #d4d4d4;">
            <div class="text-description">
              <p><strong>Visualizar em tempo real</strong></p>
              <p style="font-size: 1.3rem;">Lembre-se de verificar a caixinha de doação na sua loja</p>
            </div>
            <div class="button-description">
              <a [href]="redirectDomain" target="_blank"><button class="btn btn-success"> Ver no site</button></a>
            </div>
          </div>
          <div class="actions-go-to">
            <div class="text-description">
              <p><strong>Já configurei e agora?</strong></p>
              <p style="font-size: 1.3rem;">Acompanhe os resultados da sua ação na tela de Analytics</p>
            </div>
            <div class="button-description">
              <a href="#/profile/overview"> <button class="btn btn-info"> Ir para Analytics</button></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Caixinhas de personalização -->
    <div class="row">
      <!-- <div class="bigheader">
                <div class="col-lg-12 col-md-12">
                    <h4>Personalize sua caixinha</h4>
                    <p class="subtitle">
                        
                    </p>
                </div>
            </div> -->
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="card-header" style="display: flex;justify-content: space-between;">
            <div>
              <h4 class="card-title">Personalize o Polen na {{ customize.storeName}} </h4>
              <p class="category">Use sua criatividade! Altere texto, título e cor que mais combinam com a seu negócio e
                você.</p>
            </div>
          </div>
          <div class="card-content">
            <div id="acordeon">
              <div class="panel-group" id="accordion">
                <ng-container *ngFor="let abTest of customize.abTests; let i = index" [attr.data-index]="i">
                  <div *ngIf="abTest.name!== 'Thank you'" class="panel panel-border panel-default open"
                    [ngClass]="{'open': i==0}">
                    <a data-toggle="collapse" href="#collapse{{i}}">
                      <div class="panel-heading">
                        <h4 class="panel-title">
                          {{ abTest.pageType }} ({{ abTest.name }})
                          <i class="ti-angle-down"></i>
                        </h4>
                      </div>
                    </a>
                    <div id="collapse{{i}}" class="panel-collapse collapse" [ngClass]="{'show': i == 0}">
                      <div class="panel-body">
                        <div class="card col-md-12">
                          <div class="card-content">
                            <form name="form" class="col-md-6" (ngSubmit)="f.form.valid && saveCustomization(abTest)"
                              #f="ngForm" novalidate>
                              <div class="row">
                                <div class="col-md-8">
                                  <div class="form-group">
                                    <label> Título </label>
                                    <input class="form-control" type="text" name="title" [(ngModel)]="abTest.title"
                                      required #title="ngModel">
                                    <small [hidden]="title.valid || (title.pristine && !f.submitted)"
                                      class="text-danger">
                                      Este campo é obrigatório
                                    </small>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label> Cor principal </label>
                                    <div class="color-box">
                                      <input type="text" id="text-color" name="mainColor" [(ngModel)]="abTest.mainColor"
                                        data-control="brightness" required #mainColor="ngModel">
                                      <input id="mainColor" type="color" name="mainColor" [(ngModel)]="abTest.mainColor"
                                        data-control="brightness" required #mainColor="ngModel">
                                    </div>
                                    <small [hidden]="mainColor.valid || (mainColor.pristine && !f.submitted)"
                                      class="text-danger">
                                      Este campo é obrigatório
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <!--TEXTO SECUNDARIO - FALTA ALTERAR-->
                              <div class="row" *ngIf="abTest.seoName.indexOf('bomtroco') <  0">
                                <div class="col-md-12">
                                  <div class="form-group">
                                    <label> Texto superior</label>
                                    <small> 70 caracteres</small>
                                    <input class="form-control" type="text" name="secondText" maxlength="70"
                                      [(ngModel)]="abTest.secondText" #secondText="ngModel"
                                      placeholder="Qual causa sua compra vai ajudar?">
                                    <small style="display: none" class="text-danger">
                                      Este campo é obrigatório
                                    </small>
                                    <small>
                                      (dependendo da sua plataforma, esse texto
                                      não é exibido)
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="row" *ngIf="abTest.seoName.indexOf('bomtroco') <  0">
                                <div class="col-md-12">
                                  <div class="form-group">
                                    <label> Texto Inferior Explicativo </label>
                                    <small> 85 caracteres</small>
                                    <input class="form-control" type="text" name="text" maxlength="85"
                                      [(ngModel)]="abTest.text" required #text="ngModel">
                                    <small [hidden]="text.valid || (text.pristine && !f.submitted)" class="text-danger">
                                      Este campo é obrigatório
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="row" *ngIf="abTest.seoName.indexOf('bomtroco') >  0">
                                <div class="col-md-12">
                                  <div class="form-group">
                                    <label> Texto inicial na chave do BomTroco (ex.:
                                      NÃO)
                                    </label>
                                    <small>4 caracteres</small>
                                    <input class="form-control" type="text" name="text" maxlength="4"
                                      [(ngModel)]="abTest.text" #text="ngModel">
                                  </div>
                                </div>
                              </div>
                              <div class="text-left btn-customization">
                                <button type="submit" style="margin-bottom: 10px;"
                                  class="btn btn-info btn-fill">Atualizar
                                  dados</button>
                              </div>
                            </form>
                            <!--BOX DONATION-->
                            <div class="col-md-6 polen-box-donation" *ngIf="abTest.name !== 'Thank you'">
                              <label>O layout pode ser diferente na sua loja.</label>
                              <div class="col-md-6 offset-md-3 polen-widget"
                                [ngStyle]="{'border-color': abTest.mainColor}">
                                <div class="polen-message">
                                  <div class="polen-title-ngo">
                                    <span class="polen-text-explain">{{abTest.title}}</span>
                                    <button class="polen-ask-button" type="button"
                                      onclick="jQuery('.polen-modal').toggle();">
                                      <svg [ngStyle]="{'stroke': abTest.mainColor}" xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3">
                                        </path>
                                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                      </svg> </button>
                                  </div>
                                </div>
                                <p class="polen-ngo-text">{{ abTest.secondText }}</p>
                                <div class="polen-ngo-list row">
                                  <div *ngFor="let ngo of customize.causeIcons.ngos; let i = index"
                                    [attr.data-index]="i" class="polen-ngo-item-container">
                                    <div class="polen-ngo-item polen-ong-card" (mouseover)="hover[i]=true"
                                      (mouseleave)="verifySelected(selectedBox[i],i)"
                                      (click)="selectedBox[i]=!selectedBox[i]"
                                      [ngStyle]="{backgroundColor: hover[i]===true  ? abTest.mainColor+'40' : 'rgb(207 198 239 / 8%)', border: selectedBox[i]===true  ? 'solid 1px' : '', borderColor: selectedBox[i]===true  ? abTest.mainColor: '' }">
                                      <div class="polen-radio-image">
                                        <input type="radio" name="radio-ngo" id="radio-ngo-{{ngo.name}}"
                                          class="polen-radio regular-radio">
                                        <img class="polen-ngo-item-image" src="{{ngo.logo}}" alt="{{ngo.name}}">
                                      </div>
                                      <h4 class="polen-image-text">{{ngo.name}}
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                                <p class="polen-ngo-text">
                                  <label>{{abTest.text}}</label>
                                </p>
                                <div class="polen-container-footer">
                                  <p class="polen-powered">
                                    <a href="https://polen.com.br/impacto/{{customize.storeSeoName}}?utm_source={{customize.storeSeoName}}&amp;utm_medium=verificado_polen"
                                      target="_blank">
                                      <span>Verificado pelo</span>
                                      <img style="width: 40px !important;padding-left: 2px;"
                                        src="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/polen/logo-polen-horizontal.svg"></a>
                                  </p>
                                </div>
                                <div id="polen-modal" class="polen-modal">
                                  <div class="polen-modal-content">
                                    <span class="polen-modal-close" onclick="jQuery('.polen-modal').hide()">×</span>
                                    <div class="polen-more-info">
                                      <div class="polen-donation-about">
                                        Com o Polen nenhum valor será somado à
                                        sua compra para doar à Ong/Causa que
                                        escolher.
                                        Basta clicar na Ong/Causa que tiver mais
                                        afinidade para selecionar e Pronto!
                                      </div>
                                      <div class="polen-row-encap" *ngFor="let cause of customize.causeIcons.ngos">
                                        <div style="text-align: justify;" class="polen-more-info-row">
                                          <img class="polen-modal-image" src="{{cause.logo}}" alt="{{cause.name}}">
                                          <div style="margin: 4px 25px;">
                                            <b style="font-size: 16px; text-align: left">{{cause.name}}</b>
                                            <p style="font-size: 12px; margin:0px">
                                              {{cause.description}}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <p class="polen-modal-powered">
                                        <a href="https://polen.com.br/impacto/{{customize.storeSeoName}}?utm_source={{customize.storeSeoName}}&amp;utm_medium=verificado_polen"
                                          target="_blank" style="vertical-align: middle;">Verificado
                                          pelo</a>
                                        <img
                                          src="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/polen/logo-polen-horizontal.svg">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <!--  end acordeon -->
          </div>
        </div>
      </div>
    </div>

    <!-- Config de doações -->
    <div class="row" *ngIf="profile">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="card-bigheader">
            <h4>Dados de Doação</h4>
          </div>
          <div class="card-content text-center">
            <form name="form" (ngSubmit)="f.form.valid && saveProfile()" #f="ngForm" novalidate>
              <div class="row">
                <div class="col-md-4">
                  Tipo de Doação:
                  <div class="multichoice-container-doacoes">
                    <button type="button" [ngClass]="{'active': profile.donationType == 0 }"
                      (click)="changeDonationType(0)" class="btn-multichoice">Valor
                      Fixo</button>
                    <button type="button" [ngClass]="{'active': profile.donationType == 1 }"
                      (click)="changeDonationType(1)" class="btn-multichoice">Porcentagem</button>
                    <button type="button" *ngIf="hasRoundupEnable || isAdmin"
                      [ngClass]="{'active': profile.donationType == 3 }" (click)="changeDonationType(3)"
                      class="btn-multichoice">Arredondamento de
                      Troco</button>
                  </div>
                </div>
                <div *ngIf="profile.donationType != 3" class="col-md-2" style="padding-left: 0;">
                  <div style="padding-right: 10px;">Regras de Doação</div>
                  <div class="multichoice-container-doacoes" style="padding-right: 10px;">
                    <button type="button" (click)="changeDonationRule(0)" style="height: 50px;"
                      [ngClass]="{'active': profile.donationRule == 0 }" class="btn-multichoice">POR COMPRA</button>
                    <button type="button" (click)="changeDonationRule(1)" style="height: 50px;"
                      [ngClass]="{'active': profile.donationRule == 1 }" class="btn-multichoice">POR PRODUTO</button>
                  </div>
                </div>
                <div *ngIf="profile.donationType != 3" class="col-md-2">
                  Valor doado por compra
                  <div class="multichoice-container-doacoes" style="border:0">
                    <button type="button" (click)="changeDonationValue(profile.donationValue)"
                      *ngIf="!typeDonationValue && profile.donationValue < 1 && profile.donationValue != 1 && profile.donationValue != 5 && profile.donationValue != 10"
                      [ngClass]="{'active': !typeDonationValue }" class="btn-multichoice active">
                      <span *ngIf="profile.donationType == 0">R$</span>{{profile.donationValue}}<span
                        *ngIf="profile.donationType == 1">%</span>
                    </button>
                    <button type="button"
                      [hidden]="profile.donationValue > 10 && profile.donationValue != 1 && profile.donationValue != 5 && profile.donationValue != 10"
                      [ngClass]="{'active': profile.donationValue == 1 }" (click)="changeDonationValue(1)"
                      class="btn-multichoice">
                      <span *ngIf="profile.donationType == 0">R$</span>1<span *ngIf="profile.donationType == 1">%</span>
                    </button>
                    <button type="button" (click)="changeDonationValue(profile.donationValue)"
                      *ngIf="!typeDonationValue && profile.donationValue > 1 && profile.donationValue < 5"
                      [ngClass]="{'active': !typeDonationValue }" class="btn-multichoice active">
                      <span *ngIf="profile.donationType == 0">R$</span>{{profile.donationValue}}<span
                        *ngIf="profile.donationType == 1">%</span>
                    </button>
                    <button type="button" [ngClass]="{'active': profile.donationValue == 5 }"
                      (click)="changeDonationValue(5)" class="btn-multichoice">
                      <span *ngIf="profile.donationType == 0">R$</span>5<span *ngIf="profile.donationType == 1">%</span>
                    </button>
                    <button type="button" (click)="changeDonationValue(profile.donationValue)"
                      *ngIf="!typeDonationValue && profile.donationValue > 5 && profile.donationValue < 10"
                      [ngClass]="{'active': !typeDonationValue }" class="btn-multichoice active">
                      <span *ngIf="profile.donationType == 0">R$</span>{{profile.donationValue}}<span
                        *ngIf="profile.donationType == 1">%</span>
                    </button>
                    <button type="button"
                      [hidden]="profile.donationValue < 1 && profile.donationValue != 1 && profile.donationValue != 5 && profile.donationValue != 10"
                      [ngClass]="{'active': profile.donationValue == 10 }" (click)="changeDonationValue(10)"
                      class="btn-multichoice">
                      <span *ngIf="profile.donationType == 0">R$</span>10<span
                        *ngIf="profile.donationType == 1">%</span>
                    </button>
                    <button type="button"
                      *ngIf="!typeDonationValue && profile.donationValue > 10 && profile.donationValue != 1 && profile.donationValue != 5 && profile.donationValue != 10"
                      [ngClass]="{'active': !typeDonationValue }" class="btn-multichoice active">
                      <span *ngIf="profile.donationType == 0">R$</span>{{profile.donationValue}}<span
                        *ngIf="profile.donationType == 1">%</span>
                    </button>
                    <button type="button" (click)="typeOtherDonationValue()" class="btn-multichoice other-value"
                      [ngClass]="{'active': typeDonationValue }">
                      <span *ngIf="!typeDonationValue">OUTRO</span>
                      <div *ngIf="typeDonationValue">
                        <div class="input-group" style="width: 100%;">
                          <span *ngIf="profile.donationType == 0">R$</span>
                          <input type="number" name="donationValue" [(ngModel)]="profile.donationValue" required
                            #donationValue="ngModel" min="1" max="100">
                          <span *ngIf="profile.donationType == 1">%</span>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
                <div *ngIf="profile.donationType == 3" class="col-md-2" style="padding-left: 0;">
                  <div style="padding-right: 10px;">Valor máximo a ser arredondado</div>
                  <div class="multichoice-container-doacoes" style="padding-right: 10px;">
                    <select class="form-control" name="maxUserDonation" [(ngModel)]="profile.maxUserDonation">
                      <option [value]="1">Até R$0,99 centavos</option>
                    </select>
                    <small *ngIf="profile.maxUserDonation == 1">ex.: Compra de R$13,40 arredonda
                      para
                      R$14,00</small>
                    <small *ngIf="profile.maxUserDonation == 0.5">ex.: Compra de R$13,40 arredonda
                      para
                      R$13,50</small>
                  </div>
                </div>
                <div *ngIf="profile.donationType == 3" class="col-md-2" style="padding-left: 0;">
                  <div style="padding-right: 10px;">Valor Padrão de doação</div>
                  <div class="multichoice-container-doacoes" style="padding-right: 10px;">
                    <select class="form-control" name="defaultUserDonation" [(ngModel)]="profile.defaultUserDonation">
                      <option [value]="0.1">R$0,10 centavos</option>
                      <option [value]="0.2">R$0,20 centavos</option>
                      <option [value]="0.25">R$0,25 centavos</option>
                      <option [value]="0.3">R$0,30 centavos</option>
                      <option [value]="0.4">R$0,40 centavos</option>
                      <option [value]="0.5">R$0,50 centavos</option>
                      <option [value]="0.75">R$0,75 centavos</option>
                      <option [value]="0.9">R$0,90 centavos</option>
                    </select>
                    <small>ex.: Caso o valor do produto seja redondo, você pode adicionar uma doação
                      padrão sugerida.</small>
                  </div>
                </div>
                <!-- <div class="row">
                                    <div class="col-md-6 col-xs-12">
                                        <div class="form-group">
                                            <label>Valor máximo a ser doado no mês (opcional)</label>
                                            <div class="input-group">
                                                <span class="input-group-addon">R$</span>
                                                <input class="form-control" type="number" name="maxDonationPerMonth"
                                                [(ngModel)]="profile.maxDonationPerMonth"
                                                #maxDonationPerMonth="ngModel">
                                            </div>
                                            <small>Caso queira um limite de doação mensal</small>
                                        </div>
                                    </div>
                                </div> -->
                <div class="col-md-4">
                  <img style="width: 100%;margin-top: -70px;"
                    src="../../../assets/img/caixinha-doacao-explain-theme.gif" />
                </div>
              </div>
              <div class="row" *ngIf="changeDonation">
                <div class="col-md-12">
                  <fieldset>
                    <div class="alert alert-info alert-with-icon alert-changeDonation" data-notify="container">
                      <span data-notify="icon" class="ti-save"></span>
                      <div data-notify="message">
                        <div class="col-md-8">
                          Ao salvar as novas configurações, elas terão efeito apenas nas
                          compras realizadas após a mudança. Esteja atento às regras de
                          doação:<br>
                          <ul>
                            <li>A doação para cada Ong tem um valor mínimo de R$5,00.</li>
                            <!-- <li>O repasse da doação ocorre quando é atingido o mínimo de R$50,00</li> -->
                          </ul>
                        </div>
                        <div class="col-md-4">
                          <a (click)="saveProfile()"
                            style="background:#413179;border-color: #413179;width: 100%;font-size: 16px;"
                            class="btn btn-info btn-fill">Salvar Configurações <i class="fas fa-save"></i></a>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

      <!-- Config de Doações de Produtos -->
      <div class="row" *ngIf="profile.storeSeoName == 'vivafloresta'">
        <div class="col-lg-12 col-md-12">
          <div class="card">
            <div class="card-bigheader">
              <h4>Produtos</h4>
            </div>
            <div class="card-content text-center">
              <p class="text-card">
                Lista de Doações por Produtos e cadastro e edição do valor das doações por produtos. 
              </p>
              <p>
                <a href="/#/profile/products" target="_blank"
                  style="background:#413179;border-color: #413179;width: 40%;font-size: 16px;"
                  class="btn btn-info btn-fill">ACESSAR MEUS PRODUTOS <i class="fas fa-chevron-right"></i></a>
              </p>

            </div>
          </div>
        </div>
      </div>

    

    <div class="row">
      <div class="col-lg-7 col-md-12" *ngIf="causes != null">
        <div class="card">
          <div class="card-bigheader">
            <h4>Apoiar Causas ou Instituições</h4>
            <p class="subtitle" style="text-transform: initial;">
              Você pode apoiar causas como "Educação" ou uma instituição diretamente como "Abrinq" por
              exemplo. Consulte seu plano para verificar qual formato você pode utilizar.
            </p>
          </div>

          <div class="card-content">
            <div class="row bigheader">
              <div class="col-lg-12 col-md-12">
                <h4>CAUSAS PARA APOIAR</h4>
              </div>
            </div>
            <fieldset>
              <div class="alert alert-warning alert-with-icon" data-notify="container">
                <span data-notify="icon" class="ti-eye"></span>
                <div data-notify="message">
                  Atenção! Ao salvar as causas para apoiar, as causas/instituições anteriores deixarão
                  de aparecer em sua loja.
                </div>
              </div>
            </fieldset>

            <div class="actual-causes">
              <div class="container-causes">
                <div class="card-cause" *ngFor="let ngo of activeNgos;">
                  <input type="radio">
                  <label style="cursor: auto;">
                    <img [src]="ngo.logo" alt="Logo da {{ngo.name}}">
                    <p>{{ngo.name}}</p>
                  </label>
                </div>
                <div class="card-cause change-cause" *ngIf="!hideOngs">
                  <input type="radio">
                  <label (click)="hideOngs = true">
                    <p style="font-size: 3rem; margin: 0;">+</p>
                    <p>Alterar minhas Causas</p>
                  </label>
                </div>
                <div class="card-cause change-cause" *ngIf="hideOngs">
                  <input type="radio">
                  <label (click)="hideOngs = false">
                    <p style="font-size: 3rem; margin: 0;">-</p>
                    <p>Recolher causas</p>
                  </label>
                </div>
              </div>
            </div>

            <div class="hide-select-ong" *ngIf="hideOngs">
              <select-ngo (answer)="changeOngAnswer($event)" [type]="'causes'" [maxShow]="12" [type]="modalType"
                [maxCause]="2" [isAdmin]="isAdmin"></select-ngo>
              <!-- <cause-selector (answer)="updateCausesChoice('cause', $event)" [max]="maxCauses" [min]="2"
                                [causes]="causes" [selectedCauses]="selectedCauses" [(ngModel)]="causes">
                            </cause-selector> -->
              <div class="row">
                <!-- Arrumar para salvar as causas esse campaign não existe nesse contexto -->
                <div class="col-md-12">
                  <button *ngIf="hasChanges && ngoChangeList != null" (click)="saveChangesNgos()"
                    class="btn btn-success btn-fill btn-wd pull-right" type="button">Salvar Causas Apoiadas</button>
                  <button *ngIf="!hasChanges || ngoChangeList == null"
                    style="cursor: not-allowed;background: #c2c2c2;border-color: #c2c2c2;"
                    class="btn btn-success btn-fill btn-wd pull-right" type="button">Salvar Causas Apoiadas</button>
                  <small class="pull-right" style="padding: 10px;"
                    *ngIf="hasChanges && (campaign != null && campaign.selectedCauses.length > 0)">você possui mudanças
                    não salvas</small>
                  <small class="pull-right" style="padding: 10px;color:#5fba7d" *ngIf="successChanged">salvo com
                    sucesso</small>
                </div>
              </div>
            </div>

            <hr>
            <div>
              <div class="row bigheader">
                <div class="col-lg-12 col-md-12">
                  <div class="title-button">
                    <h4>INSTITUIÇÕES PARA APOIAR</h4>

                    <a (click)="openPopup('ngo')" class="btn btn-md btn-success btn-fill btn-wd" *ngIf="isAdmin">
                      <span class="fas fa-podcast"></span>
                      Trocar Ongs
                    </a>
                  </div>
                  <p class="subtitle">Se seu plano tem apoio direto à Ongs, acesse o portfólio,
                    escolha as
                    instituições e comunique nossa equipe qual deseja alterar.
                  </p>

                  <p>
                    <a href="https://polen.com.br/ongs" target="_blank"
                      style="background:#413179;border-color: #413179;width: 100%;font-size: 16px;"
                      class="btn btn-info btn-fill">ACESSAR PORTFÓLIO DE ONGS <i class="fas fa-chevron-right"></i></a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ícones -->
      <div class="col-lg-5 col-md-12">
        <div class="card">
          <div class="card-bigheader">
            <h4>Escolha os ícones</h4>
          </div>
          <div class="card-content">
            <div class="panel panel-border panel-default" *ngFor="let ngo of customize.causeIcons.ngos; let i = index"
              [attr.data-index]="i">
              <!--                            <div class="panel-body" style="padding: 0;">-->
              <!--                                <div class="col-lg-4 col-md-12">-->
              <!--                                    <div class="card" style="margin-bottom: 0;  display: flex;">-->
              <!--                                        <img class="causeImage" src="{{ngo.logo}}" alt="{{ngo.name}}"-->
              <!--                                            style="min-width: 70%; min-height: 70%;padding: 10px;margin: 0 auto;margin-left: 15px;" />-->
              <!--                                        <br>-->
              <!--                                        <p style="text-align: center">{{ ngo.name }}</p>-->
              <!--                                    </div>-->
              <!--                                </div>-->
              <!--                                <div class="col-lg-8 col-md-12">-->
              <!--                                    <p style="text-align: center">Escolha seu novo ícone</p>-->
              <!--                                    <div class="col-lg-3 col-md-12" style="padding-right: 5px;-->
              <!--                                    padding-left: 5px;" *ngFor="let icon of customize.causeIcons.icons; let i = index"-->
              <!--                                        [attr.data-index]="i" [hidden]="icon.ngoUrl != ngo.url">-->
              <!--                                        <div (click)="changeIcon(icon,ngo)" [hidden]="icon.ngoUrl != ngo.url"-->
              <!--                                            class="card">-->
              <!--                                            <img class="causeImage" src="{{icon.logo}}" alt="{{icon.name}}"-->
              <!--                                                style="    width: 100%;padding: 5px;" />-->
              <!--                                        </div>-->
              <!--                                    </div>-->
              <!--                                </div>-->
              <!--                            </div>-->
              <div class="container-change-ngo">
                <div class="ngo-preview card" style="margin-bottom: 0; padding-top: 20px;">
                  <img class="causeImage" src="{{ngo.logo}}" alt="{{ngo.name}}" />
                  <p>{{ ngo.name }}</p>
                </div>
                <div class="select-icon">
                  <p style="text-align: center">Escolha seu novo ícone</p>
                  <div class="col-lg-3 col-md-12" style="padding-right: 5px; padding-left: 5px; cursor: pointer;"
                    *ngFor="let icon of customize.causeIcons.icons; let i = index" [attr.data-index]="i"
                    [hidden]="icon.ngoUrl != ngo.url">
                    <div (click)="changeIcon(icon,ngo)" [hidden]="icon.ngoUrl != ngo.url" class="card">
                      <img class="causeImage" src="{{icon.logo}}" alt="{{icon.name}}"
                        style="    width: 100%;padding: 5px;" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-right">
            <button type="button" (click)="saveCauseIcons()" class="btn btn-info btn-fill"
              style="margin:1rem 2rem;">Atualizar Icones</button>
          </div>
        </div>
      </div>

      <!-- alteração genérica -->
      <div class="col-lg-7 col-md-12">
        <div class="card">
          <div class="card-bigheader">
            <h4>Alterar de maneira genérica</h4>
            <p>Insira os id's das organizações em minusculo e separado por vírgulas, NÃO use espaços</p>
            <div>
              <input type="text" id="customChange" style=" border: 1px solid; border-radius: 0px; padding-left: 5px;">
              <div class="row">
                <!-- Arrumar para salvar as causas esse campaign não existe nesse contexto -->
                <div class="col-md-12">
                  <button (click)="saveCustomNgos()" class="btn btn-success btn-fill btn-wd pull-right"
                    type="button">Salvar Causas Apoiadas</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- troca de ongs dentro de causas -->
    <div class="row">

      <div class="col-lg-12 col-md-12">
        <div class="header-container">
            <h3>Organizações apoiadas</h3>
            <p>Aqui você pode alterar a Organização apoiada dentro da sua causa.</p>
          </div>
        <div class="card" style="padding: 4rem;display: flex;">
         
          <div class="container-change-in-cause" *ngFor="let cause of activeNgos;">
            <div class="top-size card-cause">
              <input type="radio" id="{{cause.friendlyUrl}}" name="causa-apoiada" value="{{cause.friendlyUrl}}">
              <label for="{{cause.friendlyUrl}}">
                <img [src]="cause.logo" alt="Logo da {{cause.name}}">
                <p>{{cause.name}}</p>
              </label>
            </div>

            <div class="bottom-size container-selected-ngos"
              *ngIf="cause!=null && cause.ngos != null && cause.friendlyUrl != 'emergencial'">
              <div style="display: flex;justify-content: center; align-items: center; margin: 3rem 0;">
                <div class="card-ngo-cause btn-multichoice" *ngFor="let ngo of cause.ngos">
                  <input type="radio" id="{{ngo.friendlyUrl}}" name="ongs-da-causa" value="{{ngo.friendlyUrl}}">
                  <label for="{{ngo.friendlyUrl}}">
                    <img [src]="ngo.logo" alt="Logo da {{ngo.name}}">
                    <p>{{ngo.name}}</p>
                  </label>
                </div>
              </div>

              <button class="btn btn-success btn-fill change-button" (click)="category = cause.friendlyUrl">ESCOLHER
                OUTRAS ORGANIZAÇÕES</button>
            </div>

            <div 
              class="bottom-size container-selected-ngos"
              *ngIf="cause!=null && (cause.friendlyUrl == 'emergencial')"
            >

              <ng-container *ngIf="cause!=null && cause.ngos != null">
                <div style="display: flex;justify-content: center; align-items: center;">
                  <div class="card-ngo-cause btn-multichoice" *ngFor="let ngo of cause.ngos">
                    <input type="radio" id="{{ngo.friendlyUrl}}" name="ongs-da-causa" value="{{ngo.friendlyUrl}}">
                    <label for="{{ngo.friendlyUrl}}">
                      <img [src]="ngo.logo" alt="Logo da {{ngo.name}}">
                      <p>{{ngo.name}}</p>
                    </label>
                  </div>
                </div>
              </ng-container>

              <p style="font-size: 1.5rem;text-align: center;">
                Como essa causa é especial para determinados eventos, apenas os administradores podem alterar as ONGs
                dentro dela.
                Mas não se preocupe, todas as ONGs sempre estarão relacionadas a causa pretendida e em caso de dúvidas
                você pode entrar
                em contato e saber quais as ONGs que você está ajudando
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

</div>


<!--  Modal Area  -->
<div class="container-popup" *ngIf="showPopup">
  <div>
    <div class="content-popup">
      <button class="close-button" (click)="showPopup = false">X</button>
      <div class="header-popup">
        <h4 style="text-align: center">Alterar causa apoiada</h4>
        <p style="text-align: center">
          Escolha a causa que seu comercio quer apoiar.
          As organizações são escolhidas aleatóriamente, caso queira escolher doar para uma organização diretamente
          entre em contato com nosso suporte.
        </p>
      </div>
      <div class="main-popup">
        <select-ngo (answer)="changeOngAnswer($event)" [maxShow]="12" [type]="modalType" [maxCause]="2"
          [isAdmin]="isAdmin"></select-ngo>
      </div>
      <div class="footer-popup">
        <div class="row">
          <!-- Arrumar para salvar as causas esse campaign não existe nesse contexto -->
          <div class="col-md-12">
            <button *ngIf="hasChanges && ngoChangeList != null && isAdmin" (click)="saveChangesNgos()"
              class="btn btn-success btn-fill btn-wd pull-right" type="button">Salvar Causas Apoiadas</button>
            <button *ngIf="!hasChanges || ngoChangeList == null"
              style="cursor: not-allowed;background: #c2c2c2;border-color: #c2c2c2;"
              class="btn btn-success btn-fill btn-wd pull-right" type="button">Salvar Causas Apoiadas</button>
            <small class="pull-right" style="padding: 10px;"
              *ngIf="hasChanges && (campaign != null && campaign.selectedCauses.length > 0)">você possui mudanças não
              salvas</small>
            <small class="pull-right" style="padding: 10px;color:#5fba7d" *ngIf="successChanged">salvo com
              sucesso</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-popup" *ngIf="category != null">
  <div>
    <div class="content-popup">
      <button class="close-button" (click)="category = null">X</button>
      <div class="header-popup">
        <h4 style="text-align: center">Alterar causa apoiada</h4>
        <p style="text-align: center">
          Escolha a causa que seu comercio quer apoiar.
          As organizações são escolhidas aleatóriamente, caso queira escolher doar para uma organização diretamente
          entre em contato com nosso suporte.
        </p>
      </div>
      <div class="main-popup">
        <select-ngo (answer)="changeOngAnswer($event)" [maxShow]="12" [type]="modalType" [maxCause]="1"
          [isAdmin]="isAdmin" [category]="category"></select-ngo>
      </div>
      <div class="footer-popup">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-success btn-fill btn-wd pull-right" type="button" (click)="saveNgoInCause()">
              Salvar Causas Apoiadas
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-popup" *ngIf="isNewCostumer">
  <div class="small-content-popup">
    <button class="close-button" (click)="isNewCostumer=false">X</button>
    <div class="wow-image">
      <img src="../../assets/img/pop-up-wow-moment-caixinha-de-doacao.gif"
        alt="Três pessoas brindando a contratação do Polen">
    </div>
    <div class="wow-text">
      <h4>Parabéns, você já está gerando doações!</h4>
      <p>Uhull, o Polen já está instalado na sua loja e aparecendo no seu carrinho de compras,
        veja agora como ficou e se precisar retorne a essa tela para terminar a sua personalização, ok?
      </p>
    </div>
    <div class="wow-cta">
      <a (click)="isNewCostumer=false">Personalizar minha caixinha</a>
      <a href="{{redirectDomain}}" target="_blank" class="btn">Ver na minha loja</a>
    </div>
  </div>
</div>
